import React, { useState } from 'react';

import { Box, useTheme, useMediaQuery } from '@mui/material';

import { useOrderDetails } from 'src/stores/orders/order-details/order-details.store';

import Header from '../header/header';
import { HEADER } from '../config-layout';

export interface OrderDetailsLayoutProps {
  children: React.ReactNode;
}

export default function OrderDetailsLayout({ children }: OrderDetailsLayoutProps) {
  const { setQuickViewDrawerState } = useOrderDetails();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [hovering, setHovering] = useState(false);
  const [touchStartX, setTouchStartX] = useState<number | null>(null);

  const handleMouseEnter = () => {
    if (isDesktop) {
      setHovering(true);
      setQuickViewDrawerState(true);
    }
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (touchStartX !== null && e.touches[0].clientX - touchStartX > 150) {
      setQuickViewDrawerState(true);
      setTouchStartX(null);
    }
  };

  const handleTouchEnd = () => {
    setTouchStartX(null);
  };

  return (
    <Box
      sx={{
        background: theme.palette.background.neutral,
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <Box
        sx={{
          width: '6px',
          height: '100%',
          bgcolor: '#0d1e30',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: (t) => t.zIndex.drawer + 1,
          transition: 'background-color 0.3s',
          backgroundColor: hovering ? '#0D1E6C' : '#0D1E6C',
        }}
        onMouseEnter={handleMouseEnter}
        onClick={() => setQuickViewDrawerState(true)}
      />
      <Header />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: '100%',
          pt: { xs: `${HEADER.H_MOBILE}px`, md: `${HEADER.H_DESKTOP}px` },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
